var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-form-group',[_c('b-form-textarea',{attrs:{"rows":2,"disabled":_vm.is_item_in_cart(_vm.article),"placeholder":"Ingrese notas para el articulo"},model:{value:(_vm.notes),callback:function ($$v) {_vm.notes=$$v},expression:"notes"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }